<template>
    <div class="aggregator-icons d-flex">
        <div
            class="icon"
            v-for="(prov, index) in limitedAggregators"
            :key="index"
            v-html="prov.icon"
        ></div>

        <div
            class="icon more-count"
            v-if="hiddenCount > 0"
        >
            +{{ hiddenCount }}
        </div>
    </div>
</template>

<script>
export default {
    name: "AggregatorIcons",
    props: {
        aggregators: {
            type: Array,
            required: true
        },
        maxVisible: {
            type: Number,
            default: 2
        }
    },
    computed: {
        limitedAggregators() {
            return this.aggregators.slice(0, this.maxVisible);
        },
        hiddenCount() {
            const total = this.aggregators.length;
            return total > this.maxVisible ? total - this.maxVisible : 0;
        }
    }
};
</script>

<style scoped>
.aggregator-icons .icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    margin-right: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
}

.aggregator-icons .icon img,
.aggregator-icons .icon svg {
    max-width: 100%;
    max-height: 100%;
    border-radius: 6px;
}

.aggregator-icons .more-count {
    background-color: #e4edff;
    color: #1a3fff;
}
</style>
